import { Link } from 'react-router-dom'

const Public = () => {
    const content = (
        <section className="public">
            <header>
                <h1><span className="nowrap">BROKY</span></h1>
            </header>
            <main className="public__main">
                <address className="public__addr">
                    Please sign in or sign up.<br />
                </address>
            </main>
            <footer>
                <Link to="/login">User Login</Link>
            </footer>
        </section>

    )
    return content
}
export default Public